import DropDownButton from "components/dropDownButton/DropDownButton";
import { useAppSelector } from "hooks";
import { memo, ReactNode } from "react";
import { resellersSelector } from "selectors/domainSelectors";
import { RootState } from "store";
import styled from "styled-components";

const StyledText = styled.div`
  margin-bottom: 30px;
  text-align: center;
  padding: 0 10px;
  color: gray;
`;

interface PurchaseDropDownProps {
  domain: string;
  resellers: string[];
  drop?: "up" | "down" | "start" | "end";
}

const PurchaseDropDown = (props: PurchaseDropDownProps) => {
  const { domain, resellers, drop } = props;

  if (!resellers) return null;

  const dropDownItems = resellers?.map((value) => {
    return {
      url: `${process.env["REACT_APP_API_BASE_URL"]}/domains/buy/${value}/${domain}`,
      title: value,
    };
  });

  return (
    <DropDownButton dropDownItems={dropDownItems} drop={drop}>
      Buy
    </DropDownButton>
  );
};

export default memo(PurchaseDropDown);
